import fetch from '../apiconfig/index'
// 用户登陆
export function Login(params) {
    return fetch.post(`/api/User/Login/?t=`+new Date().getTime(), params)
}
// 注销用户
export function Logout(params) {
    return fetch.get(`/api/User/Logout/?t=`+new Date().getTime(), params)
}
/* ==============================虚拟实验相关接口============================== */
// 获取虚拟仿真实验列表
export function GetExperimentList(params) {
    return fetch.get(`/api/v1/student/Exp/GetExperimentList/?t=`+new Date().getTime(), params)
}
// 用户收藏/取消收藏
export function GetCollect(params) {
    return fetch.get(`/api/v1/student/Exp/GetCollect/?t=`+new Date().getTime(), params)
}
//获取实验信息内容统计
export function GetExperiment(params) {
	return fetch.get(`/api/v1/student/Exp/GetExperiment/?t=`+new Date().getTime(), params);
}
//获取实验报告内容及教师点评
export function GetExpReport(params) {
	return fetch.get(`/api/v1/student/Exp/GetExpReport/?t=`+new Date().getTime(), params);
}
// 保存提交实验报告
export function SubmitRe(params) {
	return fetch.post(`/api/v1/student/Exp/GetExpReport/?t=`+new Date().getTime(), params);
}
/* ==============================我的考试============================== */
// 获取当天考试列表
export function GetDayMyTest(params) {
    return fetch.get(`/api/v1/student/Test/GetDayMyTest/?t=`+new Date().getTime(), params)
}
//获取我的考试列表
export function GetMyTestList(params) {
    return fetch.get(`/api/v1/student/Test/GetMyTestList/?t=`+new Date().getTime(), params)
}
//获取试卷-试题列表
export function GetMyTestQueList(params) {
    return fetch.get(`/api/v1/student/Test/GetMyTestQueList/?t=`+new Date().getTime(), params)
}
// 提交考试答题信息
export function AddAnswerTest(params) {
    return fetch.post(`/api/v1/student/Test/AddAnswerTest/?t=`+new Date().getTime(), params)
}
/* ==============================我的成绩============================== */
// 获取已做过实验列表
export function GetExperimentArr(params) {
    return fetch.get(`/api/v1/student/Test/GetExperimentArr/?t=`+new Date().getTime(), params)
}
// 实验成绩统计图
export function GetExpScore(params) {
    return fetch.get(`/api/v1/student/Test/GetExpScore/?t=`+new Date().getTime(), params)
}
// 获取理论成绩列表
export function GetScoreList(params) {
    return fetch.get(`/api/v1/student/Test/GetScoreList/?t=`+new Date().getTime(), params)
}
// 查看试卷-试题及答题信息
export function GetTestQueList(params) {
    return fetch.get(`/api/v1/student/Test/GetTestQueList/?t=`+new Date().getTime(), params)
}

/* ==============================账号设置============================== */
// 修改账号密码
export function NewPwd(params) {
    return fetch.post(`/api/public/User/NewPwd/?t=`+new Date().getTime(), params)
}
//获取手机号信息
export function GetPhone(params) {
    return fetch.get(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params)
}
//修改新手机号
export function NewPhone(params) {
    return fetch.post(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params)
}
